export default __webpack_public_path__ + "static/media/image3.22f09372.svg";